import { reviewMatchesFilter } from "./reputation/review-filters";
import type { ReviewItem } from "./reputation/types";

/** A single queue; sensitive cases are a subset, never an additional count. */
export function reviewBoostV4Priority(reviews: ReviewItem[], base: string) {
  const pending = reviews.filter(review => reviewMatchesFilter(review, "para_revisar"));
  const sensitive = pending.filter(review => review.status === "delicada" || review.risk_level === "alto").length;
  const unanswered = reviews.filter(review => reviewMatchesFilter(review, "sin_responder")).length;
  if (pending.length) return {
    label: `${pending.length} ${pending.length === 1 ? "reseña" : "reseñas"} para revisar`,
    detail: sensitive ? `De estas, ${sensitive} ${sensitive === 1 ? "requiere" : "requieren"} revisión especial. Leé las reseñas y confirmá cada respuesta antes de publicar.` : "Revisá las respuestas disponibles antes de publicarlas.",
    path: `${base}/reviews?tab=para_revisar`, action: "Revisar respuestas", count: "Necesita tu atención",
  };
  if (unanswered) return {
    label: `${unanswered} ${unanswered === 1 ? "reseña sin" : "reseñas sin"} responder`,
    detail: "Podés preparar respuestas y revisarlas antes de publicarlas.",
    path: `${base}/reviews?tab=sin_responder`, action: "Ir a reseñas", count: "Tu próxima acción",
  };
  return { label: "Tu bandeja está al día", detail: "No encontramos reseñas que necesiten tu intervención. Podés consultar la actividad o preparar nuevas invitaciones.", path: `${base}/acquisition`, action: "Conseguir reseñas", count: "Todo al día" };
}
